import { navigateTo } from '@wix/business-manager-api';
import { useCallback } from 'react';
const referrer = 'home-assistant-widget';
const openUrl = (url, target) => {
  const urlToOpen = new URL(url);
  urlToOpen.searchParams.append('referral', referrer);
  window.open(urlToOpen.toString(), target);
};
export const useNavigation = cta => {
  const navigate = useCallback(() => {
    if (!cta) {
      return;
    } else if (cta.bizMgrNavigation) {
      const {
        pageComponentId,
        contextData
      } = cta.bizMgrNavigation.config;
      navigateTo({
        pageComponentId,
        contextData: {
          ...contextData,
          referrer
        }
      });
    } else if (cta.externalUrl) {
      openUrl(cta.externalUrl.url, '_blank');
    }
  }, [cta]);
  return {
    navigate
  };
};
//# sourceMappingURL=navigation.hook.js.map